<template>
  <ZMainPage :loading="loading" type="card">
    <div class="z-box-bg mb-2">
      <div v-if="tabIndex === 1 && !isEdit" class="flex justify-end">
        <el-button type="primary" size="small" @click="handleEditShow">编辑</el-button>
      </div>
      <div class="flex justify-between">
        <div class="mr-4 flex-shrink">
          <img class="user-img" src="@/assets/img/default-header.png">
          <div class="mt-1 fs-16 flex-center" style="margin-bottom: 4rem;">
            <span class="mr-1">{{ userInfo.name }}</span>
            <img class="user-sex" :src="`${oss}${userInfo.gender === 1 ? 'male' : 'female'}.png`">
          </div>
          <div class="fs-12">{{ userInfo.student_no }}</div>
        </div>
        <div class="flex-1">
          <LineWrapper min="300" list>
            <LineItem v-for="item in userList" :key="item.label" :label="item.label">
              <span v-if="item.value" class="mr-1">{{ item.value }}</span>
              <span v-if="item.button" class="text-primary c-p" @click="handlePreview(item.type)">{{ item.button }}</span>
            </LineItem>
            <image-viewer :list="[score_image]" :visible.sync="visible"/>
          </LineWrapper>
        </div>
      </div>
    </div>
    <div v-if="showType === 'approve'" class="tab-index-box mb-2">
      <div
        class="tab-index-item"
        :class="tabIndex === idx ? 'active' : ''"
        v-for="(item, idx) in tabMenus"
        :key="idx"
        @click="onTabClick(idx)"
      >
        {{ item }}
      </div>
    </div>
    <template v-if="tabIndex">
      <div class="z-box-bg mb-2">
        <div class="z-box-title">
          <span class="z-box-title-text">基础信息</span>
        </div>
        <el-form ref="form2" :model="form2" :rules="rules2" label-position="top" label-width="120rem" :disabled="!isEdit">
          <el-row class="flex flex-wrap">
            <el-col span="6">
              <el-form-item label="监护人姓名" prop="parent_name">
                <el-input v-model="form2.parent_name" maxlength="30" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="与学生的关系" prop="relationship">
                <el-select v-model="form2.relationship" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o10" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="form2.relationship === '其他'" span="6">
              <el-form-item label="其他与学生的关系" prop="f3">
                <el-input v-model="form2.f3" maxlength="30" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="监护人电话" prop="parent_phone">
                <el-input v-model="form2.parent_phone" maxlength="11" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="是否为独生子女" prop="is_only_one">
                <el-select v-model="form2.is_only_one" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o11" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="家庭住址" prop="home_address">
                <el-input v-model="form2.home_address" maxlength="50" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="家庭情况" prop="home_details">
                <el-input v-model="form2.home_details" maxlength="50" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="目标大学" prop="college">
                <el-input v-model="form2.college" maxlength="30" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="z-box-bg">
        <div class="z-box-title">
          <span class="z-box-title-text">线索跟进</span>
        </div>
        <el-form ref="form3" :model="form3" :rules="rules3" label-position="top" label-width="120rem" :disabled="!isEdit">
          <el-row>
            <el-col span="6">
              <el-form-item label="客户意向" prop="will">
                <el-select v-model="form3.will" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="flex flex-wrap">
            <el-col span="6">
              <el-form-item label="艺体升学意愿评级" prop="level">
                <el-select v-model="form3.level" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="家长支持度评级" prop="agree">
                <el-select v-model="form3.agree" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o3" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="预计系统学习时间" prop="study_time">
                <el-select v-model="form3.study_time" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o4" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="希望通过学校获取的支持" prop="school_support">
                <el-select v-model="form3.school_support" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o5" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="form3.school_support === '其他'" span="6">
              <el-form-item label="其他希望通过学校获取的支持" prop="f6">
                <el-input v-model="form3.f6" maxlength="10" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="意向艺体方向" prop="yiti_way">
                <el-select v-model="form3.yiti_way" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o6" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="form3.yiti_way === '其他'" span="6">
              <el-form-item label="其他意向艺体方向" prop="f8">
                <el-input v-model="form3.f8" maxlength="10" :placeholder="inputPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="是否有相关学习或训练经历" prop="is_have_trained">
                <el-select v-model="form3.is_have_trained" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o7" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="是否参加过相关比赛/考级/展览" prop="is_attend_raced">
                <el-select v-model="form3.is_attend_raced" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o8" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="跟进状态" prop="status">
                <el-select v-model="form3.status" :placeholder="selectPlaceholder">
                  <el-option v-for="item in options2.o9" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="线索来源">
                <el-input v-model="form3.f12" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="跟进次数">
                <el-input v-model="form3.f13" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="获取线索时间">
                <el-input v-model="form3.f14" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="最后跟进时间">
                <el-input v-model="form3.f15" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form3.remark" maxlength="300" :placeholder="inputPlaceholder" rows="8" show-word-limit type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
    <template v-else>
      <div class="info-box">
        <div class="info-left">
          <div v-if="showType === 'approve'" class="z-box-bg">
            <div class="z-box-title">
              <span class="z-box-title-text">艺体客情跟进</span>
            </div>
            <el-form ref="form1" :model="form1" :rules="rules1" label-position="right" label-width="120rem">
              <el-row class="flex flex-wrap">
                <el-col span="12">
                  <el-form-item label="客户意向" prop="will">
                    <el-select v-model="form1.will" placeholder="请选择">
                      <el-option v-for="item in options1.o1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="12">
                  <el-form-item label="跟进状态" prop="status">
                    <el-select v-model="form1.status" placeholder="请选择">
                      <el-option v-for="item in options1.o2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="12">
                  <el-form-item label="跟进方式" prop="method">
                    <el-select v-model="form1.method" placeholder="请选择">
                      <el-option v-for="item in options1.o3" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="12">
                  <el-form-item label="跟进时间" prop="follow_time">
                    <el-date-picker v-model="form1.follow_time" placeholder="请选择" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="12" v-if="form1.status === 1">
                  <el-form-item label="下次联系时间" prop="next_time">
                    <el-date-picker v-model="form1.next_time" placeholder="请选择" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="12">
                  <el-form-item label="跟进凭证" prop="follow_proof">
                    <ZuButtonUpload text="点击上传凭证" style="width: 250rem;" @change="onFileChange"></ZuButtonUpload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col span="24">
                  <el-form-item label="跟进记录" prop="follow_remark">
                    <el-input v-model="form1.follow_remark" maxlength="300" placeholder="请输入本次沟通主题、关键反馈以及下一步计划等信息" rows="8" show-word-limit type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <template v-if="showType === 'view'">
            <div class="z-box-bg mb-2">
              <div class="z-box-title flex align-center">
                <img style="width: 20rem;height: 20rem;margin-right: 4rem;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADzklEQVR4AexXT2gUZxT/vdnZ3f6RJvaggoWupbSFlrZr6KmCO7ceLcVAoTRREnsreqgtbUIm25Sm9KBtT8aIWkpBBaM38eAsqDeTEbzpQRE8qKjxvzu72ef7ZnbZneSb2VGT4GE/3pvvvd973/f95u0MO8/ASz46BF/0B+pUsFPB+RVwpr3+klueKs2UXdHLYu93pp9sd1zunp+7GH7iZ9BxH+cUISLeD8YmAJ8CyIndT0S7iD3XcT2FIWpsPsypsb3Vr3+dLI8XJ8p//LbX2/bnv/x6VL7CExFU1SE2HFmQE1VyBYRjogcAXEEwcsQ8pW4kcMPX8T3c9fFspcTg/8HGj0TGzhpoT7lcnRk7yGvD2U0vEUHUvO2yxCfHjNHC+uy6Qj77pegWZTPzDokryRFSI9AMz6gUQbRhfoiB99irTs7HG34igkToCxZQyerJ2oHdvFo9r+yWw1U1Aeb+ZiSw5AZkC9oaeNrrF/Z//IYu0pag43K3LKxXr3ZcbK0w6GAj4LiVQsNW8+gRpGVeIRoppocuXbAtQeCJIlhfa8zWjfipxv4NNZJGNqMi9gPRSKlmcFcXNHTgYmMkrz4I+2L2PWF/Q/d08WUhqA5Oz90fkfm0aEgIfJEy5kAIbHGWjeBP3715d+6aWVjZjeG31jCUdq/A79lsev1QH11r4RQyl42gOtW2qfbhuzizbi1D6Ucf4OQP39JDFYvSZSUYRSIO7xCMq06SWKeCSaoUl9OpYFx1ksQSVbDGgNIkGy52TizBsX2VDWenzWNnZwz46sIuTlR7F5JYOiSSYHGy8jnXcEo+UD9pHM9Mb8v//qHihNffwJZ6jiRIjF1yuPqOkyksBhnjh6W/CKNL42kJ2jabctxnolph8OpLdx6t0gYXGdQSxMb2p1TM16g1y8qnS02fQx+sTVys0MdstdFwSUAvWoK2RVWAL+iX+OhtvIMbvhW+nFcuEfp03Z1qH+QZHlE5orNW/tXnIyiLAaKdiBjykTka3EQ4QV6iv+qItKCG45wrb1JEA60USHpnifvVlUZqVOy2oq2gWjU8kD4B0FeiV9Ect6Rr+35oMPN3E2paVk/mABHtriM5MjBFbFwOtOYI7pMDVHconSDaj0iCaunwoHl0aCCVS6XMVQbMNe93mauHt2X+QczYmM/skOqoPlnbYDFD+uqMFbNFKGSEPI0jFeGft9LNXwbpem8vzWlSFkCqT5aGfiUT5Zlpi69kWIKRpemrF2zQArQl2JL7zKaVz5y35Gf3NfSWJ99qSQkmpxGd2SEYXZtkkZe+gk8BAAD//0M7J5cAAAAGSURBVAMALsczYNu2N84AAAAASUVORK5CYII="/>
                <span class="z-box-title-text">线索跟进</span>
              </div>
              <ZuTable :list="list1"></ZuTable>
            </div>
            <div class="z-box-bg">
              <div class="z-box-title flex align-center">
                <img style="width: 20rem;height: 20rem;margin-right: 4rem;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAACD0lEQVR4AexYUVLCMBB9W9Rvj4A34Ah6AuMJlFsofIgzwnAL8ATGE8AN5Ag9gt8Obdy0EGGa2gSaig47eU1YNrsv2zYbiHDgciS47w06ZjBYBsW9aove8q4ZqE7ZQqy3WPR4Qit9B2jSCCid6YTAIlaCQNKBwjlyibkLCWSxouSS4xRaCUFjF8tR6yIkTKSSQRXBkmnNqf8XQf0giz4/0Db00lcxUOvntrYU+2UwSmdQ6tIKKIFPxW99zi3bnmwLYV1u4Xb1Iwi0oYVoDsLUAFhAC+EcRqhtXYheoLGpHvgSzD2q9EUOW901WPnG2G5ROmfFUwlY7dZ2I+jgWz6fznl7GtjgMN2YBCNoIuw5OBLcM4EIlkHxsBSin0xs8CG9G0GKbjcDc8BrxnYj6vAh4M6KbcsfP/kS1KcaPn0o3qzxHRzIz3MKHzCiYmT7Jc0LvbGpHvgRTKMrgGQhoCai9WfUxUrk6GQqh9GVDSsTp86LoBwTH7+iG1tQOWL9gDYy6BS/0siLYKW3AAY1EQzAbOXSi6DoJYM6sIrt1HkRZI+PNYHduDVfgjG7rQPsxq15EZQ1/YByo5ZbeRHMpzR7/fME+e+PRPGbGwxV98OewbTF9RO1VwWUSwwd0/K9laAuaVC67iqurQ2Aa3wW05WgtpMjWmQFXxf90BiT3rp02AKsGSxY/aLiSHDf5B98Br8AAAD//w5SX/oAAAAGSURBVAMAEHVEb/1ZYIIAAAAASUVORK5CYII="/>
                <span class="z-box-title-text">基础信息</span>
              </div>
              <ZuTable :list="list2"></ZuTable>
            </div>
          </template>
        </div>
        <div class="history-wrapper">
          <div class="history-index-box">
            <div
              class="history-index-item"
              :class="historyIndex === item.value ? 'active' : ''"
              v-for="item in historyMenus"
              :key="item.value"
              v-show="!item.disabled"
              @click="onHistoryIndexChange(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <div ref="historyDom" class="z-box-bg history-list-box">
            <LogList :list="followList[historyIndex]" />
          </div>
        </div>
      </div>
    </template>
    <Dialog :visible.sync="dialogShow" title="操作记录">
      <TimeLine :list="historyList" :loading="dialogLoading" line="solid" reverse depth></TimeLine>
    </Dialog>
    <template slot="footer">
      <template v-if="showType === 'view'">
        <el-button @click="$router.back()">返回</el-button>
      </template>
      <template v-if="tabIndex === 0 && showType === 'approve'">
        <el-button type="primary" :loading="submitLoading" @click="handleApproveSubmit">保存</el-button>
        <el-button :disabled="submitLoading" @click="$router.back()">返回</el-button>
      </template>
      <template  v-else-if="tabIndex === 1">
        <template v-if="isEdit">
          <el-button type="primary" :loading="submitLoading" @click="handleEditSubmit">保存</el-button>
          <el-button :disabled="submitLoading" @click="handleEditCancel">{{ showType === 'edit' ? '返回' : '取消编辑' }}</el-button>
        </template>
        <template v-else>
        <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary" @click="handleDialog">查看操作记录</el-button>
        </template>
      </template>
    </template>
  </ZMainPage>
</template>

<script>
import TimeLine from '@/components/common/TimeLine'
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import Dialog from '@/components/common/Dialog'
import ZuButtonUpload from '@/components/common/ZuButtonUpload'
import ZuTable from '@/components/common/ZuTable'
import LogList from '../components/Log'
import http, { changeObjToArr, get_history } from '@/api'
import { validatePhone } from '@/utils/validate'
import { formatDate } from '@/utils'
export default {
  _config:{route:[{path:'approve',meta:{title:'跟进'}},{path:'edit',meta:{title:'编辑'}},{path:'view',meta:{title:'查看'}}]},
  components: { TimeLine, LineWrapper, LineItem, Dialog, ZuButtonUpload, ZuTable, LogList },
  data() {
    const validateDate = (_rule, value, callback) => {
      if (!value) return callback(new Error('请选择'))
      if (this.form1.follow_time) {
        const v1 = formatDate(value)
        const v2 = formatDate(this.form1.follow_time)
        if (v1.timeStamp < v2.timeStamp) return callback(new Error('下次联系时间不能早于跟进时间'))
      }
      callback()
    }
    return {
      oss: process.env.VUE_APP_URL_OSS + "student-management/",
      loading: false,
      submitLoading: false,
      dialogLoading: false,
      dialogShow: false,
      showType: '',
      isEdit: false,
      inputPlaceholder: '',
      selectPlaceholder: '',
      photo: '',
      userInfo: {},
      userList: [],
      historyList: [],
      followList: [],
      tabMenus: ['跟进记录', '详细资料'],
      tabIndex: 0,
      historyMenus: [],
      historyIndex: 0,
      form1: {
        will: '',
        status: '',
        method: '',
        follow_time: formatDate().date,
        follow_proof: '',
        next_time: '',
        follow_remark: ''
      },
      rules1: {
        will: [{ required: true, message: '请选择', trigger: 'change' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }],
        method: [{ required: true, message: '请选择', trigger: 'change' }],
        follow_time: [{ required: true, message: '请选择', trigger: 'change' }],
        next_time: [{ required: true, validator: validateDate, trigger: 'change' }],
        follow_remark: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      data2: {},
      data3: {},
      form2: {
        parent_name: '',
        relationship: '',
        f3: '',
        parent_phone: '',
        is_only_one: '',
        home_address: '',
        home_details: '',
        college: '',
      },
      rules2: {
        parent_name: [{ required: true, message: '请输入', trigger: 'change' }],
        relationship: [{ required: true, message: '请选择', trigger: 'change' }],
        f3: [{ required: true, message: '请输入', trigger: 'change' }],
        parent_phone: [{ required: true, validator: (_, value, callback) => validatePhone(value, callback), trigger: 'change' }],
        is_only_one: [{ required: true, message: '请选择', trigger: 'change' }],
        home_address: [{ required: true, message: '请输入', trigger: 'change' }],
        home_details: [{ required: true, message: '请输入', trigger: 'change' }],
        college: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      form3: {
        will: '',
        level: '',
        agree: '',
        study_time: '',
        school_support: '',
        f6: '',
        yiti_way: '',
        f8: '',
        is_have_trained: '',
        is_attend_raced: '',
        status: '',
        f12: '',
        f13: '',
        f14: '',
        f15: '',
        remark: ''
      },
      rules3: {
        will: [{ required: true, message: '请选择', trigger: 'change' }],
        level: [{ required: true, message: '请选择', trigger: 'change' }],
        agree: [{ required: true, message: '请选择', trigger: 'change' }],
        study_time: [{ required: true, message: '请选择', trigger: 'change' }],
        school_support: [{ required: true, message: '请选择', trigger: 'change' }],
        f6: [{ required: true, message: '请输入', trigger: 'change' }],
        yiti_way: [{ required: true, message: '请选择', trigger: 'change' }],
        f8: [{ required: true, message: '请输入', trigger: 'change' }],
        is_have_trained: [{ required: true, message: '请选择', trigger: 'change' }],
        is_attend_raced: [{ required: true, message: '请选择', trigger: 'change' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }],
        remark: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      options1: {
        o1: [],
        o2: [],
        o3: [],
      },
      options2: {
        o1: [],
        o2: [],
        o3: [],
        o4: [],
        o5: [],
        o6: [],
        o7: [],
        o8: [],
        o9: [],
        o10: [],
        o11: [],
      }
    }
  },
  created() {
    if (this.$route.path.includes('approve')) {
      this.showType = 'approve'
    } else if (this.$route.path.includes('view')) {
      this.showType = 'view'
    } else if (this.$route.path.includes('edit')) {
      this.showType = 'edit'
      this.tabIndex = 1
      this.handleEditShow()
    }
    this.getData()
    this.getLog()
  },
  methods: {
    onHistoryIndexChange(index) {
      this.historyIndex = index
      this.$refs.historyDom.scrollTo(0, 0)
    },
    getLog() {
      const list = ['艺体跟进记录', '留学跟进记录', '单招跟进记录']
      const data = { student_id: this.$route.query.student_id }
      Promise.allSettled([
        http({ url: '/work/muti-study-follow/list-yiti-log', pre: 'api2' }, data),
        http({ url: '/work/muti-study-follow/list-liuxue-log', pre: 'api2' }, data),
        http({ url: '/work/muti-study-follow/list-danzhao-log', pre: 'api2' }, data),
      ]).then((results) => {
        const arr1 = []
        const arr2 = []
        results.forEach((item, index) => {
          const disabled = !index ? false : item.status === 'fulfilled' ? item.value.length === 0 : true
          arr1.push({ label: list[index], value: index, disabled })
          arr2.push(item.status === 'fulfilled' ? item.value : [])
        })
        this.historyMenus = arr1
        this.followList = arr2
      })
    },
    getData() {
      this.loading = true
      http({ url: '/1v1/sys-config/get', pre: 'api2' }, { key: 'muti_study_follow' }).then(res => {
        const { yiti: data, yiti_log: data2 } = res
        this.options1.o1 = changeObjToArr(data2.will, true)
        this.options1.o2 = changeObjToArr(data2.status, true)
        this.options1.o3 = changeObjToArr(data2.method, true)

        const relationship = changeObjToArr(data.relationship)
        const support = changeObjToArr(data.school_support)
        const ways = changeObjToArr(data.yiti_way)

        this.options2.o1 = changeObjToArr(data.will, true)
        this.options2.o2 = changeObjToArr(data.level, true)
        this.options2.o3 = changeObjToArr(data.agree, true)
        this.options2.o4 = changeObjToArr(data.study_time, true)
        this.options2.o5 = support
        this.options2.o6 = ways
        this.options2.o7 = changeObjToArr(data.is_have_trained, true)
        this.options2.o8 = changeObjToArr(data.is_attend_raced, true)
        this.options2.o9 = changeObjToArr(data.status, true)
        this.options2.o10 = relationship
        this.options2.o11 = changeObjToArr(data.is_only_one, true)

        http({ url: '/work/muti-study-follow/show-yiti', pre: 'api2' }, { id: this.$route.query.id }).then(res => {
          if (res.photo) {
            this.photo = res.photo
          }
          this.userInfo = {
            id: res.id,
            student_id: res.student_id,
            name: res.student_name,
            gender: res.student_gender,
            student_no: res.student_no,
          }
          const list = [
            { label: '跟进状态', value: res.status_name },
            { label: '客户意向', value: res.will_name },
            { label: '学费缴纳情况', value: res.fee_status },
            { label: '校区', value: res.school_name },
            { label: '年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '跟进人（班主任）', value: res.teacher_name },
            { label: '民族', value: res.nation_name },
            { label: '出生日期', value: res.birthday },
            { label: '学习方向', value: res.learning_direction_name },
            { label: '专业方向', value: res.major_name },
          ]
          this.userList = list
          if (this.showType === 'view') {
            return this.getView(res)
          }
          const isOther = relationship.some(item => item.value === res.relationship)
          const obj1 = {
            parent_name: res.parent_name,
            relationship: res.relationship ? isOther ? res.relationship : '其他' : '',
            f3: isOther ? '' : res.relationship,
            parent_phone: res.parent_phone,
            is_only_one: res.is_only_one,
            home_address: res.home_address,
            home_details: res.home_details,
            college: res.college,
          }
          const isOther1 = support.some(item => item.value === res.school_support)
          const isOther2 = ways.some(item => item.value === res.yiti_way)
          const obj2 = {
            will: res.will,
            level: res.level,
            agree: res.agree,
            study_time: res.study_time,
            school_support: res.school_support ? isOther1 ? res.school_support : '其他' : '',
            f6: isOther1 ? '' : res.school_support,
            yiti_way: res.yiti_way ? isOther2 ? res.yiti_way : '其他' : '',
            f8: isOther2 ? '' : res.yiti_way,
            is_have_trained: res.is_have_trained,
            is_attend_raced: res.is_attend_raced,
            status: res.status,
            f12: res.source_from,
            f13: res.follow_times,
            f14: res.source_time,
            f15: res.last_time,
            remark: res.remark,
          }
          this.form2 = { ...obj1 }
          this.data2 = { ...obj1 }
          this.form3 = { ...obj2 }
          this.data3 = { ...obj2 }
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },
    getView(res) {
      let list1 = [
        { label: '跟进状态', value: res.status_name, valueStyle: { color: '#F12222'} },
        { label: '客户意向', value: res.will_name },
        { label: '跟进次数', value: res.follow_times },
        { label: '艺体升学意愿评级', value: res.level_name },
        { label: '家长支持度评级', value: res.agree_name },
        { label: '预计系统学习时间', value: res.study_time_name },
        { label: '意向艺体方向', value: res.yiti_way },
        { label: '是否有相关学习或训练经历', value: res.is_have_trained_name },
        { label: '是否参加过相关比赛/考级/展览', value: res.is_attend_raced_name },
        { label: '线索来源', value: res.source_from },
        { label: '获取线索时间', value: res.source_time ? formatDate(res.source_time).date : '' },
        { label: '最后跟进时间', value: res.last_time ? formatDate(res.last_time).date : '' },
        { label: '备注', value: res.remark, class: 'full left' },
      ]
      let list2 = [
        { label: '监护人姓名', value: res.parent_name },
        { label: '与学生的关系', value: res.relationship },
        { label: '监护人电话', value: res.parent_phone },
        { label: '是否为独生子女', value: res.is_only_one_name },
        { label: '家庭地址', value: res.home_address },
        { label: '家庭情况', value: res.home_details },
        { label: '目标大学', value: res.college},
        { label: '希望通过学校获取的支持', value: res.school_support },
        { label: '', value: '' },
      ]
      this.list1 = list1
      this.list2 = list2
    },
    onTabClick(idx) {
      if (this.isEdit) {
        this.handleEditCancel()
      }
      this.tabIndex = idx
    },
    onFileChange(val) {
      this.form1.follow_proof = val
    },
    handleApproveSubmit() {
      this.$refs.form1.validate(valid => {
        if (valid) {
          const data = { ...this.form1, follow_yiti_id: this.$route.query.id }
          this.submitLoading = true
          http({ url: '/work/muti-study-follow/add-yiti-log', method: 'post', pre: 'api2' }, { ...data }).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
          })
          .finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleEditSubmit() {
      this.$refs.form2.validate(valid2 => {
        this.$refs.form3.validate(valid3 => {
          if (valid2 && valid3) {
            const { relationship, f3, ...other1 } = this.form2
            const { school_support, f6, yiti_way, f8, f12, f13, f14, f15, ...other2 } = this.form3
            const data = { id: this.userInfo.id, student_id: this.userInfo.student_id, relationship, school_support, yiti_way, ...other1, ...other2 }
            if (relationship === '其他') {
              data.relationship = f3
            }
            if (school_support === '其他') {
              data.school_support = f6
            }
            if (yiti_way === '其他') {
              data.yiti_way = f8
            }
            this.submitLoading = true
            http({ url: '/work/muti-study-follow/edit-yiti', method: 'post', pre: 'api2' }, { ...data }).then(() => {
              this.$message.success('保存成功')
              this.$router.back()
            })
            .finally(() => {
              this.submitLoading = false
            })
          }
        })
      })
    },
    handleEditShow() {
      this.isEdit = true
      this.inputPlaceholder = '请输入'
      this.selectPlaceholder = '请输入'
    },
    handleEditCancel() {
      if (this.showType === 'edit') {
        return this.$confirm('页面内容尚未保存, 是否继续返回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.back()
        })
      }
      this.form2 = { ...this.data2 }
      this.form3 = { ...this.data3 }
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.form2?.clearValidate()
        this.$refs.form3?.clearValidate()
      })
    },
    handleDialog() {
      this.dialogShow = true
      if (this.historyList.length) return
      this.dialogLoading = true
      get_history({ tbl_name: 'muti_study_follow_yiti ', tbl_id: this.$route.query.id }).then(res => {
        const { list } = res
        if (list) {
          this.historyList = list.map((item) => ({ content: item.change_detail }))
        }
      }).finally(() => {
        this.dialogLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-img {
  width: 100rem;
  height: 100rem;
  object-fit: cover;
}
.user-sex {
  width: 20rem;
  height: 20rem;
}
.tab-index {
  &-box {
    padding: 0 24rem;
    background-color: #fff;
    display: flex;
  }
  &-item {
    position: relative;
    margin-right: 60rem;
    font-size: 24rem;
    color: #333;
    line-height: 66rem;
    cursor: pointer;
    &.active {
      color: #326FFF;
      font-weight: 500;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4rem;
        background-color: #326FFF;
        border-radius: 4rem;
      }
    }
  }
}
.info-box {
  position: relative;
  height: fit-content;
  display: grid;
  grid-template-columns: 1fr 740rem; /* 右侧固定740rem，左侧占剩余宽度 */
  gap: 20rem;
}
.history {
  &-wrapper {
    width: 740rem;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    /* 核心属性：最大高度等于父容器高度（即左侧高度），超出滚动 */
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
  &-index {
    &-box {
      height: 70rem;
      display: flex;
      align-items: end;
      flex-shrink: 0;
    }
    &-item {
      position: relative;
      width: 200rem;
      padding: 0;
      font-size: 24rem;
      color: #666;
      line-height: 56rem;
      text-align: center;
      cursor: pointer;
      border-radius: 10rem 10rem 0 0;
      transition: padding 0.2s;
      background-color: #F6F6F6;
      &.active {
        padding: 8rem 0;
        color: #507AFD;
        font-weight: 500;
        background-color: #fff;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 60rem;
          height: 3rem;
          background-color: #507AFD;
          border-radius: 4rem;
        }
      }
    }
  }
  &-list {
    &-box {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}
</style>

